import { styled, Theme } from '@mui/material';

export const sxStyles = {
  container: {
    padding: '2.75rem 1.25rem 4rem',
  },
  sectionTitle: (theme: Theme) => ({
    color: theme.palette.primary.main,
  }),
  sectionItemTitle: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '2.5rem',
  },
  tooltipIcon: {
    marginLeft: '0.5rem',
    height: '20px',
    cursor: 'pointer',
  },
  stateItem: {
    display: 'flex',
    paddingRight: '1rem',

    '& > svg:first-of-type': {
      marginRight: '0.75rem',
    },
  },
};

export const StyledStatesWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '1rem',
  marginTop: '2.5rem',

  '> :not(:last-of-type)': {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
}));
